"use client";

import type { AssistantRouteContext } from "@agroproj/backend/convex/assistant/routeContext";
import type { createAssistantTools } from "@agroproj/backend/convex/assistant/tools";
import { useChat } from "@ai-sdk/react";
import { DefaultChatTransport, type InferUITools, type UIDataTypes, type UIMessage } from "ai";
import { useMemo } from "react";
type AssistantTools = InferUITools<ReturnType<typeof createAssistantTools>>;
export type AssistantToolName = keyof AssistantTools;

/** Chat messages typed by the backend tool set. Saved history restores proposal ids as metadata. */
export type AssistantUIMessage = UIMessage<{
  proposalIds?: string[];
}, UIDataTypes, AssistantTools>;
export function useAssistantChat(routeContext: AssistantRouteContext, history?: {
  threadId: string;
  revision: number;
}) {
  const transport = useMemo(() => new DefaultChatTransport<AssistantUIMessage>({
    api: "/api/assistant",
    prepareSendMessagesRequest: ({
      messages
    }) => ({
      body: {
        messages,
        routeContext: {
          pathname: routeContext.pathname
        },
        ...(history ? {
          history: {
            ...history,
            requestId: messages.at(-1)?.id ?? crypto.randomUUID()
          }
        } : {})
      }
    }),
    body: {
      routeContext: {
        pathname: routeContext.pathname
      }
    }
  }), [routeContext.pathname, history?.threadId, history?.revision]);
  return useChat<AssistantUIMessage>({
    id: `${routeContext.organizationSlug}:${history?.threadId ?? "temporary"}`,
    transport
  });
}